import type { TaskStatus } from '../../types/tasks';

export interface TaskStageTheme {
  /** Tinted band behind a lane's header. */
  header: string;
  /** Solid status dot. */
  dot: string;
  /** Header label colour, readable on `header`. */
  title: string;
  /** Count pill when the lane holds work. */
  count: string;
}

/**
 * Per-status lane theming. Each lane wears its status as a tinted header band so
 * a board reads To Do / In Progress / Done by colour at a glance, not by reading
 * labels. All values are semantic design-system tokens (theme-aware, brand-safe) —
 * `neutral-tone` is the slate family, `info` blue, `success` green. Full literal
 * class strings so Tailwind's content scan can see them (no runtime interpolation).
 *
 * Shared rather than private to the board: the Workspace "My Tasks" card shows
 * the same stages, and a second copy of these colours would drift.
 */
export const TASK_STAGE_THEME: Record<TaskStatus, TaskStageTheme> = {
  todo: {
    header: 'bg-neutral-tone-subtle',
    dot: 'bg-neutral-tone',
    title: 'text-neutral-tone-foreground',
    count: 'bg-neutral-tone text-white',
  },
  in_progress: {
    header: 'bg-info-subtle',
    dot: 'bg-info',
    title: 'text-info-foreground',
    count: 'bg-info text-white',
  },
  done: {
    header: 'bg-success-subtle',
    dot: 'bg-success',
    title: 'text-success-foreground',
    count: 'bg-success text-white',
  },
};
